require('./bootstrap');

window.dateFormat = "DD.MM.YYYY";
window.dateTimeFormat = "DD.MM.YYYY HH:mm";
window.timeFormat = "HH:mm";

window.moment.defaultFormat = window.dateTimeFormat;
